import { CompanyBusinessUnitAddress } from '@/src/lib/company-business-unit-address/types';

export type CompanyBusinessUnit = {
  defaultBillingAddress: string | null;
  name: string;
  email: string;
  phone: string;
  externalUrl: string;
  bic: string;
  iban: string;
  accountNumber: string;
  priceReferenceProjectNumbers?: Array<string>;
  priceReferenceQuoteIds?: Array<string>;
  company: string;
};

export type DeserializedCompanyBusinessUnit = CompanyBusinessUnit & {
  id: string;
  companyBusinessUnitAddresses: Array<CompanyBusinessUnitAddress>;
};

export enum PRICING_REFERENCE_OPTIONS {
  PROJECT = 'p$r$o$j$e$c$t',
  QUOTE = 'q$u$o$t$e',
}
